import { number, object, string } from 'yup'
import { classifyWallUpdate, INVALID_WALL_UPDATE_MESSAGE } from './utils'

interface WallGeometryValidationContext {
  /** start and end of the saved wall; not given for a draft, which isn't saved yet */
  savedWall?: { start: Point; end: Point }
}

export const wallGeometrySchema = object({
  guid: string(),
  start: object({
    x: number(),
    y: number(),
    z: number(),
  }),
  end: object({
    x: number(),
    y: number(),
    z: number(),
  }),
  placement: string(),
}).test('valid-wall-update', INVALID_WALL_UPDATE_MESSAGE, function (values) {
  const { savedWall } = (this.options.context ?? {}) as WallGeometryValidationContext
  if (!savedWall || !values.start || !values.end) return true

  const { x: startX, y: startY } = values.start
  const { x: endX, y: endY } = values.end
  if ([startX, startY, endX, endY].some(value => value === undefined)) return true

  const update = classifyWallUpdate(
    savedWall,
    { x: startX as number, y: startY as number },
    { x: endX as number, y: endY as number },
  )
  // reported on `start`, the alert in the form fields explains it
  return update.kind !== 'invalid' || this.createError({ path: 'start' })
})
